import { activityFeedLoaded } from '../actions/activityFeedLoaded';
import { getActivityFeed } from '../service/getActivityFeed';
import { trace } from 'owa-trace';
import { activityFeedItemsSeen } from '../actions/activityFeedItemsSeen';
import { getActivityFeedStore } from '../store/store';
import { getFilter } from './loadActivityFeedSettings';
import { setUnseenActivityCount } from '../actions/toggleActivityFeed';

export default async function loadActivityFeed(markItemsAsSeen: boolean = false) {
    const feedPromise = getActivityFeed(await getFilter());
    return feedPromise
        .then(value => {
            if (value) {
                activityFeedLoaded(value);
                /// Only markItemsAsSeen if the boolean flag is set to true
                if (markItemsAsSeen) {
                    var store = getActivityFeedStore();
                    const items = [...store.items.values()];

                    // markItemsSeen with resetUnseenCount=true only for opx flows and unseenActivityCount > 0
                    var resetUnseenCount = store.isOpx && store.unseenActivityCount > 0;
                    activityFeedItemsSeen(
                        items.filter(item => !item.isSeen).map(item => item.id),
                        resetUnseenCount
                    );

                    setUnseenActivityCount(0);
                }
            }
        })
        .catch(function (err) {
            trace.warn('Failed to load activity feed items ' + err.message);
        });
}
